import gql from 'graphql-tag';

export default gql`
  mutation completeUploadFileMutation($fileName: String, $uploadId: String, $parts: [FilePartInfoDataTCInput]) {
    completeUploadFileMutation(fileName: $fileName, uploadId: $uploadId, parts: $parts) {
      bucket
      uploadId
      key
      location
    }
  }
`;
